export const completitionEmailOptions = [
  {
    value: 'on_individual_completion',
    label: 'Send on completion of individual survey',
  },
  {
    value: 'on_closed',
    label: 'Send to all individuals when survey is closed',
  },
  {
    value: 'on_demand',
    label: 'Send all on demand',
  },
];
